import React from 'react';
import MissingValue from './MissingValue';

export interface MoneyCellProps {
  amount?: number | null;
  currency?: string | null;
  /** Where the number came from, e.g. "list · Local Market · 6 Sep". */
  rule?: React.ReactNode | string | null;
  ruleTone?: 'muted' | 'paid';
  align?: 'right';
  /** Compact rows hide the rule line. */
  compact?: boolean;
  missingLabel?: string;
}

const MoneyCell: React.FC<MoneyCellProps> = ({
  amount,
  currency,
  rule,
  ruleTone = 'muted',
  align,
  compact,
  missingLabel,
}) => {
  const wrap: React.CSSProperties = align === 'right' ? { textAlign: 'right' } : {};

  if (amount === null || amount === undefined) {
    return (
      <div style={wrap}>
        <MissingValue label={missingLabel ?? 'no price'} compact={compact} />
      </div>
    );
  }

  return (
    <div style={wrap}>
      <span style={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
        {Number(amount).toLocaleString('en-US', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })}
        {currency && (
          <span style={{ fontWeight: 400, color: '#8a94a6', fontSize: 11.5, marginLeft: 3 }}>
            {currency}
          </span>
        )}
      </span>
      {!compact && rule ? (
        <span
          style={{
            display: 'block',
            fontSize: 11.5,
            marginTop: 1,
            whiteSpace: 'nowrap',
            color: ruleTone === 'paid' ? '#1a7f4b' : '#8a94a6',
          }}
        >
          {rule}
        </span>
      ) : null}
    </div>
  );
};

export default MoneyCell;
